import i18n from 'i18next';
import detector from 'i18next-browser-languagedetector';
import {initReactI18next} from 'react-i18next';
import _includes from 'lodash/includes';

const convertLanguage = l => {
  if (!l) {
    return 'en';
  }
  const f2 = l.substr(0, 2);
  if (_includes(['es', 'en', 'ja', 'cn', 'fr', 'tw'], f2)) {
    return f2;
  }
  return 'en';
};

i18n
  .use(detector)
  .use(initReactI18next)
  .on('initialized', () => i18n.changeLanguage(convertLanguage(i18n.language)))
  .init({
    debug: process.env.NODE_ENV === 'development',
    defaultNS: 'resource',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    nsSeperator: false,
    keySeparator: false,
    ns: ['resource', 'validation'],
    react: {
      wait: true,
    },
    resources: {
      en: {
        resource: require('./en'),
      },
      ja: {
        resource: require('./ja'),
      },
      es: {
        resource: require('./es'),
      },
      cn: {
        resource: require('./cn'),
      },
      tw: {
        resource: require('./tw'),
      },
      fr: {
        resource: require('./fr'),
      },
      dev: {
        resource: require('./dev'),
      },
    },
  });

export default i18n;
